import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useAuth } from 'src/contexts/auth'
import { PregnancyDiagnosisController } from 'src/controllers/pregnancy-diagnosis.controller'
import { IAnimal } from 'src/dto/animal.dto'
import { MontaTypes } from 'src/dto/couple-planning.dto'

interface CreateMultipleCouplesParams {
  animals: IAnimal[]
  commonData: {
    idTouro: string
    dataInicio: string
    dataFim?: string | null
    tipoMonta: MontaTypes
    inseminador?: string
    dosagem?: string
  }
}

const pregnancyDiagnosisController = new PregnancyDiagnosisController()

export function useCreateMultipleCouples() {
  const { userFarm: farmId } = useAuth()

  return useMutation({
    mutationKey: ['createMultipleCouples'],
    mutationFn: (params: CreateMultipleCouplesParams) =>
      pregnancyDiagnosisController.createMultipleCouples(farmId!, params.animals, params.commonData),
    onError: () => {
      toast.error('Erro ao criar casais em lote')
    }
  })
}
